<template>
  <div
    class="modal fade"
    id="GetFreeApiModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="GetFreeApiModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" v-if="verification_sent">
        <div class="verification-sent">
          <p>A email has been sent, please click the link to activiate your account</p>
          <v-icon
            name="check"
            style="height: 3rem; backgroundColor: #16abbd; 
           margin: 1rem auto; border-radius: 25px; color:white; border: 4px #16abbd solid"
          ></v-icon>
        </div>
      </div>

      <div v-if="!verification_sent" :class="page + '-background' + ' modal-content'">
        <p
          v-if="page == 'terminal-page'"
          style="text-align: center; padding: 1rem; background:rgb(74,74,74,0.6) "
        >Please sign in to see the preview of results</p>
        <div :class="page +'-tab' + ' tab_change'">
          <selector
            :selected="tabSelected"
            :selectors="selectors"
            :handleSelector="setTabSelected"
          />
        </div>
        <div class="signup-modal" v-if="tabSelected">
          <div v-if="this.page !== 'terminal-page'" class="modal-header">
            <h5 class="modal-title">Register for free today, get insights about 70,000+ companies!</h5>
          </div>

          <div class="modal-body mx-3">
            <div class="input-field-row">
              <div class="input-field-item">
                <label class="md-form mb-4 pure-material-textfield-outlined" style="width: 95%">
                  <input
                    :class="page + '-input' +' form-control validate'"
                    type="text"
                    id="signupForm-firstname"
                    v-model="firstName"
                    placeholder=" "
                  />
                  <span :class="page +'-span'">First Name</span>
                  <p class="error-message">{{this.firstname_message || "&nbsp;"}}</p>
                </label>
              </div>
              <div class="input-field-item">
                <label class="md-form mb-4 pure-material-textfield-outlined" style="width: 95%">
                  <!-- <label data-error="wrong" data-success="right" for="signupForm-username">Your username</label> -->
                  <input
                    :class="page + '-input' +' form-control validate'"
                    type="text"
                    id="signupForm-lastname"
                    class="form-control validate"
                    v-model="lastName"
                    placeholder=" "
                  />
                  <span :class="page +'-span'">Last Name</span>
                  <p class="error-message">{{this.lastname_message || "&nbsp;"}}</p>
                </label>
              </div>
            </div>

            <label class="md-form mb-4 pure-material-textfield-outlined">
              <!-- <label data-error="wrong" data-success="right" for="signupForm-email">Your email</label> -->
              <input
                :class="page + '-input' +' form-control validate'"
                type="email"
                id="signupForm-email"
                class="form-control validate"
                v-model="signup_email"
                placeholder=" "
              />
              <span :class="page +'-span'">Email</span>
              <p class="error-message">{{this.email_message || "&nbsp;"}}</p>
            </label>

            <label class="md-form mb-4 pure-material-textfield-outlined">
              <!-- <label data-error="wrong" data-success="right" for="signupForm-pass">Set password</label> -->
              <input
                :class="page + '-input' +' form-control validate'"
                type="password"
                id="signupForm-pass"
                class="form-control validate"
                v-model="signup_password"
                placeholder=" "
              />
              <span :class="page +'-span'">Password</span>
              <p class="error-message">{{this.password_message || "&nbsp;"}}</p>
            </label>
            <label class="md-form mb-4 pure-material-textfield-outlined">
              <!-- <label data-error="wrong" data-success="right" for="signupForm-pass">Confirm password</label> -->
              <input
                :class="page + '-input' +' form-control validate'"
                type="password"
                id="signupForm-pass2"
                class="form-control validate"
                v-model="signup_password2"
                placeholder=" "
              />
              <span :class="page +'-span'">Confirm Password</span>
              <p class="error-message">{{this.password2_message || "&nbsp;"}}</p>
              <p class="error-message">{{signup_error || "&nbsp;"}}</p>
            </label>
            <label class="md-form mb-4 pure-material-textfield-outlined">
              <!-- <label data-error="wrong" data-success="right" for="signupForm-pass">Confirm password</label> -->
              <!-- <input
                :class="page + '-input' +' form-control validate'"
                type="password"
                id="signupForm-pass2"
                class="form-control validate"
                v-model="signup_password2"
                placeholder=" "
              />-->
              <select class="custom-select role-select" v-model="signup_role">
                <option selected>I’m best described as a ...</option>
                <option value="Institutional investor">Institutional investor</option>
                <option value="Individual investor">Individual investor</option>
              </select>
              <!-- <span :class="page +'-span'">Confirm Password</span> -->
              <p class="error-message">{{this.role_message || "&nbsp;"}}</p>
              <p class="error-message">{{signup_error || "&nbsp;"}}</p>
            </label>
            <div class="row mb-4">
              <div style="margin: auto; width: 19rem;">
                <p style="font-size: 12px;">
                  By signing up, you agree to UniBit
                  <a
                    id="modal_link"
                    data-toggle="modal"
                    data-target="#privacy"
                  >Privacy policy</a> and
                  <a id="modal_link" data-toggle="modal" data-target="#terms">Terms of Use</a>.
                </p>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                v-if="!loading"
                :class="page +'-button'+' submit-btn btn btn-primary'"
                @click="checkSignup()"
              >Sign Up</button>
            </div>
            <pulse-loader
              v-if="loading"
              :loading="loading"
              :color="loading_color"
              :size="loading_size"
            ></pulse-loader>

            <p v-if="!loading">Or continue with</p>
            <div class="d-flex flex-row justify-content-center mb-4 social-icons">
              <img
                src="@/assets/imgs/google.png"
                class="social-icon"
                ref="google-auth"
                @click="googleOAuth"
                v-if="!loading"
              />
              <img
                src="@/assets/imgs/linkedin.png"
                class="social-icon"
                ref="linkedin-auth"
                @click="linkedinOAuth"
                v-if="!loading"
              />
            </div>
          </div>
        </div>

        <div class="signup-modal" v-if="!tabSelected">
          <div v-if="this.page !== 'terminal-page'" class="modal-header">
            <h5 class="modal-title">Register for free today, get insights about 70,000+ companies!</h5>
          </div>

          <div class="modal-body mx-3">
            <label class="md-form mb-4 pure-material-textfield-outlined">
              <!-- <label data-error="wrong" data-success="right" for="signupForm-email">Your email</label> -->
              <input
                :class="page + '-input' +' form-control validate'"
                type="email"
                id="signupForm-email"
                class="form-control validate"
                v-model="login_email"
                placeholder=" "
              />
              <span :class="page +'-span'">Email</span>
              <p class="error-message">{{this.email_message || "&nbsp;"}}</p>
            </label>

            <label class="md-form mb-4 pure-material-textfield-outlined">
              <!-- <label data-error="wrong" data-success="right" for="signupForm-pass">Set password</label> -->
              <input
                :class="page + '-input' +' form-control validate'"
                type="password"
                id="signupForm-pass"
                class="form-control validate"
                v-model="login_password"
                placeholder=" "
              />
              <span :class="page +'-span'">Password</span>

              <p class="error-message">{{this.password_message || "&nbsp;"}}</p>
              <p class="error-message">{{this.login_error || "&nbsp;"}}</p>
              <router-link
                :to="{ name: 'forgot-password' }"
                :class="page + '-password' +' forgotPassword'"
              >Forgot your password?</router-link>
            </label>

            <div class="modal-footer">
              <button
                type="button"
                v-if="!loading"
                :class="page +'-button'+' submit-btn btn btn-primary'"
                @click="checkLogin"
              >Sign In</button>
            </div>
            <pulse-loader
              v-if="loading"
              :loading="loading"
              :color="loading_color"
              :size="loading_size"
            ></pulse-loader>

            <p v-if="!loading">Or continue with</p>
            <div class="d-flex flex-row justify-content-center mb-4 social-icons">
              <img
                src="@/assets/imgs/google.png"
                class="social-icon"
                ref="google-auth"
                @click="googleOAuth"
                v-if="!loading"
              />
              <img
                src="@/assets/imgs/linkedin.png"
                class="social-icon"
                ref="linkedin-auth"
                @click="linkedinOAuth"
                v-if="!loading"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @author Chenfeng Liu
 * @description This modal is for users to enter an email and get free api.
 * @module modal
 * @name GetFreeApiModal
 */
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Selector from "@/components/fixed/selector";
import oauth from "@/utils/oauth";
import globalConstants from "@/utils/global-constants.js";

export default {
  props: {
    page: {
      type: String,
      default: ""
    }
  },
  components: {
    Selector,
    PulseLoader
  },
  data() {
    return {
      // tab variables
      tabSelected: 0,
      selectors: ["Sign in", "Sign up"],

      // Form Inputs
      firstName: "",
      lastName: "",
      signup_email: "",
      signup_password: "",
      signup_password2: "",
      signup_role: "I’m best described as a ...",
      login_email: "",
      login_password: "",
      login_error: "",
      signup_error: "",

      // State Variables
      loading: false,
      logged: false,
      loading_color: "lightgreen",
      loading_size: "1rem",
      verification_sent: false,
      tabSelected: 0,
      // Error Messages
      firstname_message: "",
      lastname_message: "",
      email_message: "",
      password_message: "",
      password2_message: ""
    };
  },

  methods: {
    googleOAuth() {
      this.loading = true;
      const redirect_url = globalConstants.OAUTH_GOOGLE_REDIRECT_URL;
      let client_id =
        "339015305647-v5und7jql55810ujo7suqu49obrn24t1.apps.googleusercontent.com";
      let ggOAuth = new oauth(
        `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${client_id}&scope=openid%20profile%20email&redirect_uri=${redirect_url}&state=state&nonce=0394852-3190485-2490358&`,
        "Google",
        { width: 527, height: 582 }
      );

      ggOAuth.open(redirect_url).then(res => {
        console.log("Success Google Oauth", res);
        this.$store.dispatch("googleOAuthLogin", { ...res, redirect_url }).then(
          resp => {
            console.log("[GoogleOAuthLogin] Success", resp);
            this.setWindowLocalStorage("email", resp.data.email);
            this.setWindowLocalStorage("token", resp.data.token);
            this.setWindowLocalStorage("role", resp.data.role);
            this.setWindowLocalStorage("apikey", resp.data.apikey);

            this.setWindowLocalStorage(
              "expirationDate",
              new Date(Date.now() + 1000 * 3600 * 24 * 30) // 30 days
            );
            this.$store.commit("setUserEmail", resp.data.email);

            this.$store.commit("authUser", resp.data);
            this.loading = false;
            $("#GetFreeApiModal").modal("hide");
            mixpanel.register({
              email: resp.data.email,
              method: "oauth_google"
            });
          },
          error => {
            console.log("[GoogleOAuthLogin] Fail", error);
            if (error.message == "Network Error") {
              this.login_error = "*oops... please try again later";
              this.signup_error = "*oops... please try again later";
            } else {
              this.login_error = error.response.data.message;
              this.signup_error = error.response.data.message;
            }
            this.loading = false;
          },
          err => {
            console.log("Failed Google Oauth", err);
            this.$store.dispatch("notify", {
              info: err,
              type: "error"
            });
            this.loading = false;
          }
        );
      });
    },

    linkedinOAuth() {
      this.loading = true;
      const redirect_url = globalConstants.OAUTH_LINKEDIN_REDIRECT_URL;
      let lnOAuth = new oauth(
        "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86f1r0asmt8600&redirect_uri=" +
          redirect_url +
          "&scope=r_liteprofile%20r_emailaddress%20w_member_social",
        "Linkedin",
        { width: 527, height: 582 }
      );

      lnOAuth.open(redirect_url).then(
        res => {
          console.log("Success linkedin Oauth", res);
          this.$store
            .dispatch("linkedinOAuthLogin", { ...res, redirect_url })
            .then(
              resp => {
                console.log("[linkedinOAuthLogin] Success", resp);
                this.setWindowLocalStorage("email", resp.data.email);
                this.setWindowLocalStorage("token", resp.data.token);
                this.setWindowLocalStorage("role", resp.data.role);
                this.setWindowLocalStorage("apikey", resp.data.apikey);
                this.setWindowLocalStorage(
                  "expirationDate",
                  new Date(Date.now() + 1000 * 3600 * 24 * 30) // 30 days
                );
                this.$store.commit("setUserEmail", resp.data.email);

                this.$store.commit("authUser", resp.data);
                this.loading = false;
                $("#GetFreeApiModal").modal("hide");
                mixpanel.register({
                  email: resp.data.email,
                  method: "oauth_linkedin"
                });
              },
              error => {
                console.log("[linkedinOAuthLogin] Fail", error);
                if (error.message == "Network Error") {
                  this.login_error = "*oops... please try again later";
                  this.signup_error = "*oops... please try again later";
                } else {
                  this.login_error = error.response.data.message;
                  this.signup_error = error.response.data.message;
                }
                this.loading = false;
              }
            );
        },
        err => {
          console.log("Failed linkedin Oauth", err);
          this.$store.dispatch("notify", {
            info: err,
            type: "error"
          });
          this.loading = false;
        }
      );
    },

    submitSignUpForm() {
      // Step 1: obtain form data
      const { firstName, lastName } = this;
      const formData = {
        firstName,
        lastName,
        email: this.signup_email,
        password: this.signup_password
      };
      console.log("[submitSignUpForm] formData is: ", formData);

      // Step 2: sign up ()
      this.$store
        .dispatch("signup", formData)
        .then(message => {
          this.verification_sent = true;
          this.loading = false;
          // if (message == "success send email!") this.verification_sent = true;
        })
        .catch(err => {
          console.log(err);
          this.email_message =
            "The email address is already in use by another account.";
          this.loading = false;
        });
    },

    setTabSelected(index) {
      this.tabSelected = index;
      this.resetMessage();
    },

    login() {
      const vm = this;
      const formData = {
        email: this.login_email,
        password: this.login_password
      };
      this.$store
        .dispatch("login", {
          email: formData.email,
          password: formData.password
        })
        .then(res => {
          console.log(res);
          window.localStorage.setItem("email", formData.email);
          window.localStorage.setItem("token", res.data.token);
          window.localStorage.setItem("role", res.data.role);
          window.localStorage.setItem("apikey", res.data.apikey);
          window.localStorage.setItem(
            "expirationDate",
            new Date(Date.now() + 1000 * 3600 * 24 * 30) // 30 days
          );
          console.log("[get-free-api-modal] login() res.data is: ", res.data);
          this.$store.commit("authUser", res.data);
          $("#GetFreeApiModal").modal("hide");
          // this.$router.replace("/");
          mixpanel.register({
            email: formData.email,
            method: "email_password"
          });
        })
        .catch(error => {
          console.log("error", error);
          this.login_error = error.response.data.message;
        });
    },

    checkLogin() {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.resetMessage();
      if (!re.test(String(this.login_email))) {
        this.email_message = "*Invalid email format";
      }
      if (this.login_password.trim().length < 10) {
        this.password_message =
          "*Password must be at least 10 characters long!";
      } else {
        this.login();
      }
    },

    resetMessage() {
      this.email_message = "";
      this.password_message = "";
      this.firstname_message = "";
      this.lastname_message = "";
      this.email_message = "";
      this.password2_message = "";
      this.role_message = "";
      this.signup_error = "";
    },

    checkSignup() {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.resetMessage();
      let error = false;
      if (this.firstName.length < 1) {
        this.firstname_message = "*Please provide your first name";
        error = true;
      }
      if (this.lastName.length < 1) {
        this.lastname_message = "*Please provide your last name";
        error = true;
      }
      if (!re.test(String(this.signup_email))) {
        this.email_message = "*Invalid email format";
        error = true;
      }
      // get the global constant
      const len = this.$globalConstants.MIN_PASSWORD_LENGTH || 10;
      if (this.signup_password.length < len) {
        this.password_message = `*Password must be at least ${len} characters long`;
        error = true;
      }
      if (this.signup_password.trim() !== this.signup_password2.trim()) {
        this.password2_message = "*Passwords need to match!";
        error = true;
      }
      if (this.signup_role === "I’m best described as a ...") {
        this.role_message = "*Please select your role!";
        error = true;
      }
      if (!error) {
        this.loading = true;
        this.submitSignUpForm();
      }
    }
  }
};
</script>

<style scoped lang="css">
* {
  font-family: Raleway;
}

.error-message {
  font-size: 12px;
  color: red;
  /* margin-top: -10px;
  margin-bottom: 10px; */
  float: left;
}

.modal-content {
  border-radius: 0;
  /* box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), */
  /* 0 5px 15px 0 rgba(0, 0, 0, 0.08); */
  box-shadow: inset 0 0 9px 0 rgba(191, 190, 190, 0.5);
}

.modal-header {
  border-bottom: none;
}

.modal-footer {
  border-top: none;
  padding-top: 0;
  padding-bottom: 0;
}

.modal-title {
  margin: auto;
  color: #4a4a4a;
  font-weight: bold;
  font-size: 18px;
}

.modal-body {
  text-align: center;
  padding-bottom: 0;
}

.submit-btn {
  margin: auto;
  margin-bottom: 1.5rem;
  width: 70%;
  background-color: #f5a623;
}

.btn-primary {
  border-color: #f5a623;
}

.signedUp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #16abbd;
}

.verification-sent {
  padding: 2.5rem;
  text-align: center;
}

.tab_change {
  width: auto;
  /* margin: auto; */
  /* margin: 1.6875rem 0 0 0; */
  color: #4a4a4a;
}
.forgotPassword {
  float: right;
  margin-top: 0.5rem;

  border: none;
  color: #337ab7;
  cursor: pointer;

  font-family: Jura;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.47px;
  color: #f5a623;
}

#modal_link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.verification-sent p {
  margin: 1rem;
  font-size: 1.5rem;
}

.pure-material-textfield-outlined {
  /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  position: relative;
  width: 75%;
  display: inline-block;
  margin: auto;
  padding-top: 6px;
  font-family: var(
    --pure-material-font,
    "Roboto",
    "Segoe UI",
    BlinkMacSystemFont,
    system-ui,
    -apple-system
  );
  margin-bottom: 0 !important;
  font-size: 16px;
  line-height: 1.5;
  overflow: hidden;
}

/* style for terminal page modal*/

.terminal-page-background {
  background: #2f4552;
}

.terminal-page-span {
  color: #f5a623 !important;
  /* border-color: #f5a623; */
}

.pure-material-textfield-outlined
  > input.terminal-page-input:not(:focus):placeholder-shown {
  border-top-color: #f5a623;
}

.pure-material-textfield-outlined > input.terminal-page-input {
  /* border-color: #f5a623 ; */
  border-bottom-color: #f5a623;
  border-left-color: #f5a623;
  border-right-color: #f5a623;
  color: #f5a623;
}
.pure-material-textfield-outlined > input.terminal-page-input + span::before {
  margin-right: 4px;
  border-color: #f5a623;
  border-left: solid 1px #f5a623;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input.terminal-page-input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-color: #f5a623;
  border-right: solid 1px #f5a623;
  border-radius: 0 4px;
}

button.terminal-page-button {
  background: #f5a623;
  border-color: #f5a623;
}

.terminal-page-tab {
  margin-top: 1rem;
}

.terminal-page-password {
  color: #f5a623 !important;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input,
.pure-material-textfield-outlined > textarea {
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: #979797;
  border-top-color: transparent;
  border-radius: 4px;
  width: 100%;
  height: inherit;
  color: #9b9b9b;
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: #979797;
  width: 100%;
  max-height: 100%;
  color: #9b9b9b;
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: #979797;
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown */
.pure-material-textfield-outlined > input:not(:focus):placeholder-shown {
  border-top-color: #979797;
}

.pure-material-textfield-outlined > input:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 50px;
}

.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Focus */
.pure-material-textfield-outlined > input:focus {
  /* border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #f5a623;
  border-top-color: transparent;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input:focus + span {
  /* color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #f5a623;
}

.pure-material-textfield-outlined > input:focus + span::before,
.pure-material-textfield-outlined > input:focus + span::after {
  border-top-color: #f5a623;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

.social-icon {
  width: 48px;
  height: 48px;
  cursor: pointer;
  margin: 0 1rem 1rem;
}

.social-icons {
  margin-top: 1.5rem;
}

.selected0 {
  border-right: 2px groove;
}

.selected1 {
  border-left: 2px groove;
}

.input-field-row {
  width: 77.5%;
  display: inline-flex;
  flex-wrap: wrap;
}

.input-field-item {
  width: 50%;
  margin: 0;
}

.role-select {
  border-color: #979797;
  color: #9b9b9b;
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined > input + span,
    .pure-material-textfield-outlined > textarea,
    .pure-material-textfield-outlined > textarea + span,
    .pure-material-textfield-outlined > input + span::before,
    .pure-material-textfield-outlined > input + span::after,
    .pure-material-textfield-outlined > textarea + span::before,
    .pure-material-textfield-outlined > textarea + span::after {
      transition-duration: 0.1s;
    }
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 85%;
    margin: auto;
  }

  .pure-material-textfield-outlined {
    /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
    position: relative;
    width: 90%;
  }

  .input-field-row {
    width: 92.5%;
  }

  .input-field-item {
    width: 100%;
  }

  h5 {
    font-size: 1rem;
  }

  .selector > div {
    padding: 8px 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/get-free-api-modal.vue